import WebApiService from '../services/WebApiService';

export default class GroupsService extends WebApiService {

    constructor() {
        super();

        this.post = super.post.bind(this);
        this.get = super.get.bind(this);

        this.createStackupGroup = this.createStackupGroup.bind(this);
        this.saveStackupGroup = this.saveStackupGroup.bind(this);
        this.getMyStackupGroups = this.getMyStackupGroups.bind(this);
        this.getGroupsForStackup = this.getGroupsForStackup.bind(this);
        this.createMetricsGroup = this.createMetricsGroup.bind(this);
        this.saveMetricsGroup = this.saveMetricsGroup.bind(this);
        this.getMyMetricsGroups = this.getMyMetricsGroups.bind(this);
        this.getGroupsForMetrics = this.getGroupsForMetrics.bind(this);
        this.joinStackupGroup = this.joinStackupGroup.bind(this);
        this.joinMetricsGroup = this.joinMetricsGroup.bind(this);
        this.deleteGroup = this.deleteGroup.bind(this);
        this.deleteGroupMember = this.deleteGroupMember.bind(this);
    }

    createStackupGroup(payload, successCallback, errorCallback) {
        this.post('/api/Groups/CreateStackupGroup/', payload, successCallback, errorCallback);
    }

    saveStackupGroup(payload, successCallback, errorCallback) {
        this.post('/api/Groups/SaveGroup/', payload, successCallback, errorCallback);
    }

    getMyStackupGroups(payload, successCallback, errorCallback) {
        this.post('/api/Groups/MyStackupGroups/', payload, successCallback, errorCallback);
    }

    getGroupsForStackup(payload, successCallback, errorCallback) {
        this.post('/api/Groups/GroupsForStackup/', payload, successCallback, errorCallback);
    }

    createMetricsGroup(payload, successCallback, errorCallback) {
        this.post('/api/Groups/CreateMetricsGroup/', payload, successCallback, errorCallback);
    }

    saveMetricsGroup(payload, successCallback, errorCallback) {
        this.post('/api/Groups/SaveMetricsGroup/', payload, successCallback, errorCallback);
    }

    getMyMetricsGroups(payload, successCallback, errorCallback) {
        this.post('/api/Groups/MyMetricsGroups/', payload, successCallback, errorCallback);
    }

    getGroupsForMetrics(payload, successCallback, errorCallback) {
        this.post('/api/Groups/GroupsForMetrics/', payload, successCallback, errorCallback);
    }

    joinStackupGroup(payload, successCallback, errorCallback) {
        this.post('/api/Groups/JoinStackupGroup/', payload, successCallback, errorCallback);
    }

    joinMetricsGroup(payload, successCallback, errorCallback) {
        this.post('/api/Groups/JoinMetricsGroup/', payload, successCallback, errorCallback);
    }

    deleteGroup(payload, successCallback, errorCallback) {
        this.post('/api/Groups/DeleteGroup/', payload, successCallback, errorCallback);
    }

    deleteGroupMember(payload, successCallback, errorCallback) {
        this.post('/api/Groups/DeleteGroupMember/', payload, successCallback, errorCallback);
    }
}